(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dh-footer"] && !Shopify.designMode) return;
  try {
    

// --- IDENTIFY SECTION ID, THEN FIND FIRST BLOCK HEADER INSTANCE AND APPLY CSS CLASS --- //

(() => {
  function mark(sectionEl) {
    if (!sectionEl) return;
    // clear stale marks (editor re-renders)
    sectionEl.querySelectorAll('button.dh-footer__block-heading--button.is-first')
      .forEach(el => el.classList.remove('is-first'));

    const firstBtn = sectionEl.querySelector('button.dh-footer__block-heading--button');
    if (firstBtn) firstBtn.classList.add('is-first');
  }

  function markAll() {
    document.querySelectorAll('.dh-footer__main--container').forEach(container => {
      const sectionEl = container.closest('[id^="shopify-section-"]') || container;
      mark(sectionEl);
    });
  }

  // Storefront load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markAll);
  } else {
    markAll();
  }

  // Theme Editor hooks
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
})();


// --- DYNAMIC COLLAPSABLE CONTENT BEHAVIOUR --- //

// Initialise one footer section
function initFooterSection(root) {
  const blocks = root.querySelectorAll('.dh-footer__block-heading--container');
  if (!blocks.length) return;

  blocks.forEach(block => {
    const button  = block.querySelector('.dh-footer__block-heading--button');
    const arrow   = block.querySelector('.dh-footer__block-heading--arrow');
    const target  = button?.dataset.targetId;
    const content = target && root.querySelector('#' + target);

    if (!button || !content || !arrow) return;

    // Guard against duplicate listeners on theme editor refreshes
    if (button.dataset.dhInit === 'true') return;
    button.dataset.dhInit = 'true';

    button.addEventListener('click', () => {
      const isCurrentlyOpen = content.classList.contains('open');

      // Close any other block that is open in this section
      root.querySelectorAll('.dh-footer__block-content--collapsable.open').forEach(el => {
        if (el !== content) {
          el.classList.remove('open');
          const parentBlock   = el.closest('.dh-footer__block-heading--container');
          const parentButton  = parentBlock?.querySelector('.dh-footer__block-heading--button');
          const parentArrow   = parentBlock?.querySelector('.dh-footer__block-heading--arrow');
          parentArrow?.classList.remove('rotate');
          parentButton?.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle the clicked block
      const isOpenNow = content.classList.toggle('open', !isCurrentlyOpen);
      arrow.classList.toggle('rotate', isOpenNow);
      button.setAttribute('aria-expanded', String(isOpenNow));
    });
  });
}

// First load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-id]').forEach(initFooterSection);
});

// Theme editor AJAX reload
document.addEventListener('shopify:section:load', event => {
  const wrapper = event.target.querySelector('[data-section-id]');
  if (wrapper) initFooterSection(wrapper);
});


  } catch(e) { console.error(e); }
})();
})();
